import styled from 'styled-components';
import { ThemeColours } from '../../../../../../../common/styles/ThemeColours';
import { FontWeight } from '../../../../../../../common/styles/constants';

export const DetailView = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const Label = styled.div`
  color: ${ThemeColours.black};
  flex-shrink: 0;
  font-size: 12px;
  font-weight: ${FontWeight.SEMI_BOLD};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 120px;
`;

export const Value = styled.div`
  align-items: center;
  color: ${ThemeColours.mono700};
  display: flex;
  flex-direction: row;
  font-size: 14px;
  min-width: 0;
`;

export const Icon = styled.svg`
  color: ${ThemeColours.primary600};
  fill: currentColor;
  max-height: 24px;
  max-width: 24px;
`;

export const IconCircle = styled.div`
  align-items: center;
  background-color: ${ThemeColours.mono200};
  border-radius: 100%;
  display: flex;
  flex-shrink: 0;
  height: 20px;
  justify-content: center;
  margin-inline-end: 8px;
  width: 20px;
`;

export const HelpIconWrapper = styled.div`
  cursor: pointer;
  margin-inline-start: 4px;
  position: relative;
`;
